<template>
  <div class="divBox">
    <el-card class="box-card">
      <el-form
        ref="formValidate"
        v-loading="fullscreenLoading"
        class="formValidate mt20"
        label-width="160px"
        v-model="formValidate"
        @submit.native.prevent
      >
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="IOS更新地址：" prop="iosAddress">
              <el-input v-model="formValidate.iosAddress"  />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="ios版本控制：" prop="iosAppVersion">
              <el-input v-model="formValidate.iosAppVersion"  />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="IOS是否强制更新：" prop="iosOpenUpgrade">
              <el-radio-group v-model="formValidate.iosOpenUpgrade">
                <el-radio :label="1">开启</el-radio>
                <el-radio :label="0">关闭</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="安卓文件名字：" prop="androidUploadName">
              <el-input v-model="formValidate.androidUploadName"  />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="安卓上传：" prop="androidUploadUrl">
              <el-input
                v-model="androidUploadUrl"
                class="perW50"
                placeholder="请输入文件链接"
              />
              <input
                ref="refid"
                type="file"
                style="display:none"
                @change="zh_uploadFile_change"
              >
              <el-button
                type="primary"
                icon="ios-cloud-upload-outline"
                class="uploadVideo"
                @click="zh_uploadFile"
              >
               上传文件
              </el-button>
              <el-col :span="12">
                <el-progress
                  v-if="upload.videoIng"
                  :percentage="progress"
                  :text-inside="true"
                  :stroke-width="20"
                  style="margin-top: 10px;"
                />
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="安卓更新地址：" prop="androidAddress">
              <el-input v-model="formValidate.androidAddress"  />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="当前版本：" prop="appVersion">
              <el-input v-model="formValidate.appVersion"  />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="是否强制更新：" prop="openUpgrade">
              <el-radio-group v-model="formValidate.openUpgrade">
                <el-radio :label="1">开启</el-radio>
                <el-radio :label="0">关闭</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item style="margin-top:30px;">
          <el-button :loading="loading" type="primary" class="submission" size="small" @click="handleSubmit()">提交</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
import { roterPre } from '@/settings'
import {
  appraisalConfigDetailApi,
  appraisalConfigPlatformTypeApi,
  appraisalPersonDetailApi, saveAppraisalConfigDataApi,
  saveAppraisalPersonDataApi
} from "@/api/appraisal";
import {productGetTempKeysApi} from "@/api/product";
import {AppVersionConfigDetailApi, configSaveApi} from "@/api/system";
const defaultObj = {
  appraisal_title: '',
  appraisal_num: 0,
  appraisal_ai_price: 0,
  appraisal_online_price: 0,
  appraisal_offline_price: 0,
  appraisal_platform_address: '',
  appraisal_platform_name: '',
  appraisal_platform_phone: '',
  appraisal_desc: '',
  appraisal_platform_type: [],
  appraisal_images: [],
  appraisal_image_type: 1

}
export default {
  name: 'appVersionConfig',
  data() {
    return {
      roterPre: roterPre,
      fullscreenLoading: false,
      formValidate: Object.assign({}, defaultObj),
      loading: false,
      grid2: {
        xl: 10,
        lg: 12,
        md: 12,
        sm: 24,
        xs: 24
      },
      grid: {
        xl: 8,
        lg: 8,
        md: 12,
        sm: 24,
        xs: 24
      },
      progress: 0,
      androidUploadUrl: '',
      upload: {
        videoIng: false // 是否显示进度条；
      },
      provinceCodeList: [],
      propsMer: { emitPath: true },
      deliveryList: [],
    }
  },
  mounted() {
    this.getAppVersionConfig()
  },
  methods: {

    // 删除视频；
    delVideo() {
      const that = this
      that.$set(that.formValidate, 'appraisal_video_link', '')
      that.videoLink = '';
      that.progress = 0;
    },
    zh_uploadFile() {
      this.$refs.refid.click()
    },
    zh_uploadFile_change(evfile) {
      const that = this
      that.progress = 10
      const suffix = evfile.target.files[0].name.substr(
        evfile.target.files[0].name.indexOf('.')
      )
      if (suffix !== '.apk') {
        return that.$message.error('只能上传APK文件')
      }

      productGetTempKeysApi().then(res => {
        that.$videoCloud
          .videoUpload({
            type: res.data.type,
            evfile: evfile,
            res: res,
            fileName:this.formValidate.androidUploadName,
            filePath:'apk',
            uploading(status, progress) {
              that.upload.videoIng = status
            }
          })
          .then(res => {
            that.formValidate.androidUploadUrl = res.url || res.data.src
            that.formValidate.androidAddress = res.url || res.data.src
            that.androidUploadUrl = res.url || res.data.src
            that.$message.success('文件上传成功')
            that.progress = 100
          })
          .catch(res => {
            that.upload.videoIng = false
            that.$message.error(res.message)
          })
      })
    },
    // 获取数据
    getAppVersionConfig() {
      this.fullscreenLoading = true
      AppVersionConfigDetailApi(this.$route.params.id)
        .then(res => {
          this.androidUploadUrl = res.data.androidUploadUrl
          this.formValidate =  res.data
          this.fullscreenLoading = false
          this.loading = false
        })
        .catch(res => {
          this.fullscreenLoading = false
          this.$message.error(res.message)
        })
    },
    // 提交
    handleSubmit() {
      configSaveApi('app_version',this.formValidate)
        .then(res => {
          this.fullscreenLoading = false
          this.$message.success(res.message)
          this.loading = false
        })
        .catch(res => {
          this.fullscreenLoading = false
          this.loading = false
          this.$message.error(res.message)
        })
    }
  }
}
</script>
<style scoped lang="scss">
.label_tip{
  display: inline-block;
  margin-left: 20px;
  color: #C0C4CC;
}
.selWidth {
  width: 100%;
}
.selWidthd {
  width: 300px;
}
.dialog-scustom,.addDia{
  min-width: 400px;
  height: 900px;
  .el-dialog{
    width: 400px;
  }
  h3{
    color: #333;
    font-size: 16px;
    text-align: center;
    font-weight: bold;
    margin: 0;
  }
}
.pictrue {
  width: 60px;
  height: 60px;
  border: 1px dotted rgba(0, 0, 0, 0.1);
  margin-right: 10px;
  position: relative;
  cursor: pointer;
  img {
    width: 100%;
    height: 100%;
  }
}
.agreement{
  width: 350px;
  margin: 0 auto;
  box-shadow: 1px 5px 5px 2px rgba(0,0,0,.2);
  padding: 26px;
  border-radius: 15px;
  .content{
    height: 600px;
    overflow-y:scroll;
    /deep/ p{
      font-size: 13px;
      line-height: 22px;
    }
  }
  /deep/ img{
    max-width: 100%;
  }
  p{
    text-align: justify;
  }
}
/*css主要部分的样式*/
/*定义滚动条宽高及背景，宽高分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
  width: 10px; /*对垂直流动条有效*/
  height: 10px; /*对水平流动条有效*/
}
/*定义滚动条的轨道颜色、内阴影及圆角*/
::-webkit-scrollbar-track{
  /*-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);*/
  background-color: transparent;
  border-radius: 3px;
}
.iview-video-style {
  width: 40%;
  height: 180px;
  border-radius: 10px;
  background-color: #707070;
  margin-top: 10px;
  position: relative;
  overflow: hidden;
}
.iconv {
  color: #fff;
  line-height: 180px;
  display: inherit;
  font-size: 26px;
  position: absolute;
  top: -74px;
  left: 50%;
  margin-left: -25px;
}
.iview-video-style .mark {
  position: absolute;
  width: 100%;
  height: 30px;
  top: 0;
  background-color: rgba(0, 0, 0, 0.5);
  text-align: center;
}
.uploadVideo {
  margin-left: 10px;
}
.perW50 {
  width: 50%;
}
.submission {
  margin-left: 10px;
}
.btndel {
  position: absolute;
  z-index: 1;
  width: 20px !important;
  height: 20px !important;
  left: 46px;
  top: -4px;
}
.pictrue {
  width: 60px;
  height: 60px;
  border: 1px dotted rgba(0, 0, 0, 0.1);
  margin-right: 10px;
  position: relative;
  cursor: pointer;
  img {
    width: 100%;
    height: 100%;
  }
}

</style>
